<template>
  <!-- 编辑界面 -->
  <el-drawer :title="title" :visible.sync="editFormVisible" @click="closeDialog" :size="600" :wrapperClosable="false"
    :modal="false" :destroy-on-close="true" class="margin_top_40">
    <el-form label-width="8.75rem" :model="editForm" ref="editForm" :rules="rules" style="margin-bottom: 60px;">
      <el-divider content-position="left">基础信息</el-divider>
      <el-form-item label="所属门店：" prop="belongStoreKeyId">
        <el-select v-model="editForm.belongStoreKeyId" placeholder="请选择门店" clearable size="small" class="input_200px">
          <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户姓名" prop="name">
        <el-input class="input_200px" size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入客户姓名">
        </el-input>
      </el-form-item>
      <el-form-item label="电话" prop="phone">
        <el-input class="input_200px" size="small" v-model="editForm.phone" auto-complete="off" placeholder="请输入电话">
        </el-input>
      </el-form-item>
      <el-form-item label="年龄" prop="age">
        <el-input class="input_200px" size="small" type="text" v-model.number="editForm.age" auto-complete="off"
          placeholder="请输入年龄">
        </el-input>
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <el-radio-group v-model="editForm.gender" class="input_200px">
          <el-radio-button :label="1">男</el-radio-button>
          <el-radio-button :label="0">女</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="顾客类型" prop="customerType">
        <el-select v-model="editForm.customerType" placeholder="请选择顾客类型" clearable size="small" class="input_200px">
          <el-option v-for="item in customerTypeList" :label="item.value" :value="item.keyId"
            :key="item.keyId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="档案编号" prop="customerNo">
        <el-input class="input_200px" size="small" v-model="editForm.customerNo" auto-complete="off"
          placeholder="请输入档案编号">
        </el-input>
      </el-form-item>


      <el-divider content-position="left">右眼参数</el-divider>
      <el-form-item label="球镜" prop="rParams.qiuJing">
        <el-input class="input_200px" size="small" type="text" v-model="editForm.rParams.qiuJing" auto-complete="off"
          placeholder="请输入球镜" step="0.25" :precision="2" @change="formatNestedNumber('rParams', 'qiuJing', $event)">
        </el-input>
      </el-form-item>
      <el-form-item label="柱镜" prop="rParams.zhuJing">
        <el-input class="input_200px" size="small" type="text" v-model="editForm.rParams.zhuJing" auto-complete="off"
          placeholder="请输入柱镜" step="0.25" :precision="2" @change="formatNestedNumber('rParams', 'zhuJing', $event)">
        </el-input>
      </el-form-item>
      <el-form-item label="轴位" prop="rParams.zhouWei">
        <el-input class="input_200px" size="small" type="text" v-model="editForm.rParams.zhouWei" auto-complete="off"
          placeholder="请输入轴位" step="1" min="0" max="180">
        </el-input>
      </el-form-item>
      <el-form-item label="瞳高" prop="rParams.tongGao">
        <el-input class="input_200px" size="small" type="text" v-model="editForm.rParams.tongGao" auto-complete="off"
          placeholder="请输入瞳高" step="0.1">
        </el-input>
      </el-form-item>
      <el-form-item label="瞳距" prop="rParams.tongJu">
        <el-input class="input_200px" size="small" type="text" v-model="editForm.rParams.tongJu" auto-complete="off"
          placeholder="请输入瞳距" step="0.1">
        </el-input>
      </el-form-item>
      <el-form-item label="矫正视力" prop="rParams.jiaoZhengShiLi">
        <el-input class="input_200px" size="small" type="number" v-model="editForm.rParams.jiaoZhengShiLi"
          auto-complete="off" placeholder="请输入矫正视力" step="0.1">
        </el-input>
      </el-form-item>


      <el-divider content-position="left">左眼参数</el-divider>
      <el-form-item label="球镜" prop="lParams.qiuJing">
        <el-input class="input_200px" size="small" type="text" v-model="editForm.lParams.qiuJing" auto-complete="off"
          placeholder="请输入球镜" step="0.25" :precision="2" @change="formatNestedNumber('lParams', 'qiuJing', $event)">
        </el-input>
      </el-form-item>
      <el-form-item label="柱镜" prop="lParams.zhuJing">
        <el-input class="input_200px" size="small" type="text" v-model="editForm.lParams.zhuJing" auto-complete="off"
          placeholder="请输入柱镜" step="0.25" :precision="2" @change="formatNestedNumber('lParams', 'zhuJing', $event)">
        </el-input>
      </el-form-item>
      <el-form-item label="轴位" prop="lParams.zhouWei">
        <el-input class="input_200px" size="small" type="number" v-model="editForm.lParams.zhouWei" auto-complete="off"
          placeholder="请输入轴位" min="0" max="180">
        </el-input>
      </el-form-item>
      <el-form-item label="瞳高" prop="lParams.tongGao">
        <el-input class="input_200px" size="small" type="number" v-model="editForm.lParams.tongGao" auto-complete="off"
          placeholder="请输入瞳高" step="0.1">
        </el-input>
      </el-form-item>
      <el-form-item label="瞳距" prop="lParams.tongJu">
        <el-input class="input_200px" size="small" type="number" v-model="editForm.lParams.tongJu" auto-complete="off"
          placeholder="请输入瞳距" step="0.1">
        </el-input>
      </el-form-item>
      <el-form-item label="矫正视力" prop="lParams.jiaoZhengShiLi">
        <el-input class="input_200px" size="small" type="number" v-model="editForm.lParams.jiaoZhengShiLi"
          auto-complete="off" placeholder="请输入矫正视力" step="0.1">
        </el-input>
      </el-form-item>
    </el-form>
    
    <div class="drawer-footer">
      <el-button size="small" icon="el-icon-check" :loading="loading" @click="submitForm('editForm')">
        保存
      </el-button>
      <el-button v-if="!editForm.isCreateVip && this.$checkBtnPermission('/customer/index', 'createVip')" size="small"
        icon="el-icon-plus" :loading="loading" type="primary" @click="createVip()">
        创建会员
      </el-button>
    </div>
    <!-- 创建会员卡 -->
    <el-dialog :visible.sync="dialogVisible" title="创建会员卡" style="width: 60%; margin: auto;z-index: 99999;"
      append-to-body :close-on-click-modal="false">
      <span style="display: block; margin-bottom: 10px"><strong>会员卡号:</strong></span>
      <el-input v-model="vipCardNumber" placeholder="请输入会员卡号" style="width: 100%;" maxLength="50"></el-input>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="isSubmitting" @click="handleCreateVip">确认</el-button>
      </span>
    </el-dialog>
  </el-drawer>
</template>

<script>
import {
  saveCustomerInfo,
  getCustomerInfoDetail,
} from "@/api/baseDataApi.js";
import {
  GetOrganizationListByConfig
} from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import {
  AddCustomerVip
} from "@/api/vipApi.js";
export default {
  data() {
    return {
      title: "",
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      editForm: {
        keyId: "",
        name: "",
        age: 20,
        gender: 1,
        phone: "",
        belongStoreKeyId: "",
        customerType: 1,
        customerNo: "",
        lParams: {
          qiuJing: "",
          zhuJing: "",
          tongGao: "",
          tongJu: "",
          zhouWei: "",
          jiaoZhengShiLi: "",
        },
        rParams: {
          qiuJing: "",
          zhuJing: "",
          tongGao: "",
          tongJu: "",
          zhouWei: "",
          jiaoZhengShiLi: "",
        },
        isCreateVip: false,
      },
      // rules 表单验证
      rules: {
        name: [
          {
            required: true,
            message: "请输入客户姓名",
            trigger: "blur",
          },
        ],
        belongStoreKeyId: [
          {
            required: true,
            message: "请选择客户所属门店",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入联系电话",
            trigger: "blur",
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        customerType: [
          {
            required: true,
            message: "请选择顾客类型",
            trigger: "blur",
          },
        ],
        customerNo: [
          {
            required: true,
            message: "请输入档案编号",
            trigger: "blur",
          },
        ],
        age: [
          {
            required: true,
            message: "请输入年龄",
            trigger: "blur",
          },
        ],
        gender: [
          {
            required: true,
            message: "请选择性别",
            trigger: "blur",
          },
        ],
      },
      storeList: [],
      dialogVisible: false,
      vipCardNumber: "",
      isSubmitting: false,
      customerTypeList: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    //显示编辑界面
    editShow(row) {
      this.GetOrganizationListByConfig();
      if (row != undefined && row != "undefined") {
        this.title = "编辑";
        let parmer = {
          keyId: row.keyId,
        };
        getCustomerInfoDetail(parmer)
          .then((res) => {
            if (res.code == 1) {
              this.editForm = res.data;
              this.editFormVisible = true;
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$message.error("客户信息获取失败!");
          });
      } else {
        this.title = "新增";
        this.$data.editForm = this.$options.data.call(this).editForm;
        this.editFormVisible = true;
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          saveCustomerInfo(this.editForm)
            .then((res) => {
              if (res.code == 1) {
                this.$parent.getListData();
                this.$message({
                  type: "success",
                  message: "客户保存成功！",
                });
                this.editFormVisible = false;
                this.loading = false;
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              //   this.editFormVisible = false;
              this.loading = false;
              this.$message.error("客户保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
      this.$data.editForm = this.$options.data.call(this).editForm;
    },
    // 获取所属门店
    GetOrganizationListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrganizationListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 格式化嵌套对象中的数字为两位小数
    formatNestedNumber(parent, field, value) {
      if (value !== '' && value !== null && value !== undefined) {
        this.$nextTick(() => {
          var val = parseFloat(value).toFixed(2);
          if (val > 0) {
            this.editForm[parent][field] = "+" + val;
          } else {
            this.editForm[parent][field] = val;
          }
        });
      }
    },
    // 创建会员
    createVip() {
      this.dialogVisible = true;
    },
    // 处理创建会员逻辑
    handleCreateVip() {
      const paramer = {
        keyId: this.editForm.keyId,
        VipNo: this.vipCardNumber,
      };
      if (!this.vipCardNumber) {
        this.$message.error("请输入会员卡号！");
        return;
      }
      this.isSubmitting = true;
      AddCustomerVip(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "会员创建成功！",
            });
            this.dialogVisible = false;
            this.editFormVisible = false;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("会员创建失败，请稍后再试！");
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    // 获取顾客类型
    GetEnumConfigListByCode() {
      const paramer = {
        code: "CustomerType",
      };
      GetEnumConfigListByCode(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.customerTypeList = [];
            res.data.forEach((item) => {
              this.customerTypeList.push({
                keyId: parseInt(item.code),
                value: item.name,
              });
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取顾客类型信息失败!");
        });
    },
  },
  created() {
    this.GetEnumConfigListByCode();
  },
  mounted() { },
  components: {},
};
</script>
<style scoped>
.wip {
  width: 200px !important;
}
</style>